import apis from '../apis/apis'

const xacMinhVanBangProcessor = {}
const controllerName = 'XacMinhVanBang'

xacMinhVanBangProcessor.getAll = async () => {
  const rs = await apis[controllerName].GetAll({})
  return rs.isSuccess ? rs.data.values : []
}
xacMinhVanBangProcessor.getXacMinhVanBang = async (id) => {
  const rs = await apis[controllerName].GetXacMinhVanBang({ param: `/${id}` })
  return rs
}
xacMinhVanBangProcessor.createsWithFile = async (data) => {
  const submitData = { ...data }
  const formdata = new FormData()
  const request = {}
  if (submitData.file) {
    formdata.append('file', submitData.file)
  }
  Object.keys(submitData).forEach((key) => {
    const value = submitData[key]
    if (value !== null) {
      formdata.append(key, value)
    }
  })

  request.formData = true
  request.data = formdata

  const rs = await apis[controllerName].CreatesWithFile({
    method: 'post',
    ...request,
  })
  return rs
}
xacMinhVanBangProcessor.upsert = async (data) => {
  const submitData = { ...data }
  const formdata = new FormData()
  const request = {}
  if (submitData.file) {
    formdata.append('file', submitData.file)
  }
  Object.keys(submitData).forEach((key) => {
    const value = submitData[key]
    if (value !== null) {
      formdata.append(key, value)
    }
  })

  request.formData = true
  request.data = formdata

  const rs = await apis[controllerName].CreateWithFile({
    method: 'post',
    responseType: 'text',
    ...request,
  })
  return rs
}
xacMinhVanBangProcessor.delete = async (id) => {
  const rs = await apis[controllerName].Delete({
    method: 'post',
    responseType: 'text',
    param: `/${id}`,
  })
  return rs
}

xacMinhVanBangProcessor.getByKhoaThi = async (id) => {
  const rs = await apis[controllerName].GetByKhoaThi({ param: `/${id}` })
  return rs.isSuccess ? rs.data : []
}

xacMinhVanBangProcessor.updateMany = async (data) => {
  const rs = await apis[controllerName].UpdateMany({ method: 'post', responseType: 'text', data })
  return rs
}
xacMinhVanBangProcessor.truongXacNhan = async (id) => {
  const rs = await apis[controllerName].TruongXacNhan({ param: `/${id}`, responseType: 'text' })
  return rs
}

export default xacMinhVanBangProcessor
